import React from "react";
import styles from "./StopWatchScoreComponent.module.scss";
import { Tooltip } from "@mui/material";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ScoreRangeComponent from "components/scorerange/ScoreRangeComponent";
import { truncateText } from "utils/utils";

const StopWatchScoreComponent = ({ handleDelete, item }) => {
  return (
    <>
      <div className={styles?.scoreContainer}>
        <div className={styles?.header}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Tooltip title={item?.name}>
              <span>{truncateText(item?.name || "", 50)}</span>
            </Tooltip>
            <Tooltip
              title={"Time format is HH:mm:ss. Create a range of values."}
            >
              <InfoOutlinedIcon
                fontSize="small"
                sx={{ color: "#3e9ef7", cursor: "pointer" }}
              />
            </Tooltip>
          </div>
          <span
            style={{ cursor: "pointer" }}
            onClick={() => handleDelete(item.id, item?.fieldId)}
          >
            <HighlightOffOutlinedIcon
              sx={{ color: "#3e9ef7" }}
              fontSize="medium"
            />
          </span>
        </div>
        <div className={styles?.options}>
          <ScoreRangeComponent item={item} />
        </div>
      </div>
    </>
  );
};

export default StopWatchScoreComponent;
